

// import { useNavigate } from 'react-router-dom';
// import {
//   Box, Grid, Typography, useTheme, useMediaQuery, Card, CardContent, IconButton,
//   CardMedia, Container, BottomNavigation,
//   BottomNavigationAction, Paper, Button

// } from '@mui/material';
// import { Link, useLocation } from 'react-router-dom';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import React, { useEffect, useState } from 'react';
// import pic4 from "./../../../Images/roofshuttering.webp";

// import soiltest1 from "./../../../Images/soiltest.webp";
// import pic1 from "./../../../Images/column_marking.webp";
// import pic2 from "./../../../Images/columnfoundation.jpg";
// import pic3 from "./../../../Images/plinth.avif";
// import pic5 from "./../../../Images/roofbarbending.jpg";
// import pic6 from "./../../../Images/roofconcreate.jpg";
// import pic7 from "./../../../Images/partitionwalls.jpg";
// import pic8 from "./../../../Images/flooring.jpg";
// import pic9 from "./../../../Images/electricals.jpg";
// import pic10 from "./../../../Images/plumbing.webp";
// import pic11 from "./../../../Images/fabrication.jpg";
// import pic12 from "./../../../Images/doors_windows.jpg";
// import pic13 from "./../../../Images/paintings.jpg";
// import pic14 from "./../../../Images/handover.jpg";
// import pic15 from "./../../../Images/agreement.webp";
// import { jsPDF } from "jspdf";
// import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
// import const1 from './Images/Constructionelevation.jpg'
// import const2 from './Images/2dnewpic.jpg'
// import const3 from './Images/construction3d.jpg'
// import const4 from './Images/constructionpackages.jpeg'
// import const5 from './Images/Quotations.png';
// import property_pincode_new from './../../../../src/Images/property_pincode_new.png'
// import Arrowicon from "./../Dashboard/Images/Arrowicon.png"; 



// import expimag from './Images/exp-constru-resources.jpeg';
// import Construction1 from './../../../Assets/construction1.png';
// import Construction2 from './../../../Assets/construction2.png';
// import Construction3 from './../../../Assets/construction3.png';

// const steps = [
//   { title: 'Agreement Sign', image: pic15 },
//   { title: 'Soil Test', image: soiltest1 },
//   { title: 'Column Marking', image: pic1 },
//   { title: 'Column Foundation', image: pic2 },
//   { title: 'Column Plinth', image: pic3 },
//   { title: 'Roof Shuttering', image: pic4 },
//   { title: 'Roof Barbending', image: pic5 },
//   { title: 'Roof Concrete', image: pic6 },
//   { title: 'Partitions Wall', image: pic7 },
//   { title: 'Flooring', image: pic8 },
//   { title: 'Electrical', image: pic9 },
//   { title: 'Plumbing', image: pic10 },
//   { title: 'Fabrication', image: pic11 }, // Replaced
//   { title: 'Doors and Windows', image: pic12 },
//   { title: 'Paintings', image: pic13 }, // Replaced
//   { title: 'Handover', image: pic14 },
// ];

// const chunkArray = (array, chunkSize) => {
//   const result = [];
//   for (let i = 0; i < array.length; i += chunkSize) {
//     result.push(array.slice(i, i + chunkSize));
//   }
//   return result;
// };

// const Constructions = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [chunkSize, setChunkSize] = useState(2);
//   const [value, setValue] = useState('construction');
//     const location = useLocation();

// // Inside your component:


//   // const cards = [
//   //   {
//   //     title: "Floor Plans 2D",
//   //     description: "Professional 2D plans with Detailed Measurements.",
//   //     bgImage: 'url(https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)',
//   //     path: "/two-d-plane-interior"
//   //   },
//   //   {
//   //     title: "Floor Plans 3D",
//   //     description: "Professional 3D plans with Detailed Measurements.",
//   //     bgImage: 'url(https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)',
//   //     path: "/three-d-plane-interior"
//   //   },
//   //   {
//   //     title: "Elevations",
//   //     description: "Detailed Exterior Views and facade designs.",
//   //     bgImage: 'url(https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)',
//   //     path: "/elevations"
//   //   },
//   //   {
//   //     title: "Our Construction Packages",
//   //     description: "Complete construction document sets.",
//   //     bgImage: 'url(https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)',
//   //     path: "/packages"
//   //   },
//   //   {
//   //     title: "Quotations",
//   //     description: "Detailed cost estimates and proposals.",
//   //     bgImage: 'url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)'
//   //   }
//   // ];


//   const cards = [
//     {
//       title: " Explore Construction Resources ",
//       bgImage: `url(${expimag})`,
//       path: "/explore-construction-resources"
//     },
//     {
//       title: "Floor Plans 2D",
//       description: "Professional 2D plans with Detailed Measurements.",
//       bgImage: `url(${const2})`,
//       path: "/two-d-plane-interior"
//     },
//     {
//       title: "Floor Plans 3D",
//       description: "Professional 3D plans with Detailed Measurements.",
//       bgImage: `url(${const3})`,
//       path: "/three-d-plane-interior"
//     },
//     {
//       title: "Elevations",
//       description: "Detailed Exterior Views and facade designs.",
//       bgImage: `url(${const1})`,
//       path: "/elevations"
//     },
//     {
//       title: "Our Construction Packages",
//       description: "Complete construction document sets.",
//       bgImage: `url(${const4})`,
//       path: "/packages"
//     },
//     {
//       title: "Quotations",
//       description: "Detailed cost estimates and proposals.",
//       bgImage: `url(${const5})`,
    
//     }
//   ];

//   const trustCards = [
//     { bgImage: `url(${Construction1})` },
//     { bgImage: `url(${Construction2})` },
//     { bgImage: `url(${Construction3})` }
//   ];

//   useEffect(() => {
//     const updateChunkSize = () => {
//       const width = window.innerWidth;
//       if (width >= 350 && width <= 500) {
//         setChunkSize(2);
//       } else {
//         setChunkSize(1);
//       }
//     };

//     updateChunkSize();
//     window.addEventListener('resize', updateChunkSize);
//     return () => window.removeEventListener('resize', updateChunkSize);
//   }, []);

//   const handleDownloadQuotation = () => {
//     // Create a new PDF document
//     const doc = new jsPDF();

//     // Add logo or header (you can add your own image if needed)
//     // doc.addImage(logoData, 'JPEG', 10, 10, 50, 25);

//     // Title
//     doc.setFontSize(20);
//     doc.setTextColor(40, 40, 40);
//     doc.text('CONSTRUCTION QUOTATION', 105, 30, { align: 'center' });

//     // Company Info
//     doc.setFontSize(12);
//     doc.text('Landnest Construction Co.', 105, 40, { align: 'center' });
//     doc.text('123 Construction Street, City, Country', 105, 46, { align: 'center' });
//     doc.text('Phone: +123 456 7890 | Email: contact@landnest.com', 105, 52, { align: 'center' });

//     // Client Info
//     doc.setFontSize(12);
//     doc.text('Bill To:', 20, 70);
//     doc.text('Client Name: Sample Client', 20, 78);
//     doc.text('Project Address: 123 Client Street, City', 20, 86);
//     doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 94);
//     doc.text('Quotation #: Q-2023-001', 20, 102);

//     // Table Header
//     doc.setFontSize(12);
//     doc.setTextColor(255, 255, 255);
//     doc.setFillColor(57, 106, 177);
//     doc.rect(20, 110, 170, 10, 'F');
//     doc.text('Description', 25, 116);
//     doc.text('Qty', 120, 116);
//     doc.text('Unit Price', 140, 116);
//     doc.text('Amount', 170, 116);

//     // Table Content
//     doc.setFontSize(10);
//     doc.setTextColor(0, 0, 0);
//     const items = [
//       { description: "Construction Materials (Phase 1)", quantity: 1, unitPrice: 5000, total: 5000 },
//       { description: "Labor Costs (200 hours)", quantity: 1, unitPrice: 3000, total: 3000 },
//       { description: "Design and Planning Fees", quantity: 1, unitPrice: 2000, total: 2000 },
//       { description: "Permits and Approvals", quantity: 1, unitPrice: 500, total: 500 },
//       { description: "Roofing Materials", quantity: 1, unitPrice: 2500, total: 2500 },
//       { description: "Electrical Installation", quantity: 1, unitPrice: 1500, total: 1500 }
//     ];

//     let y = 120;
//     items.forEach((item, index) => {
//       // Alternate row colors
//       if (index % 2 == 0) {
//         doc.setFillColor(240, 240, 240);
//         doc.rect(20, y, 170, 10, 'F');
//       }

//       doc.text(item.description, 25, y + 7);
//       doc.text(item.quantity.toString(), 120, y + 7);
//       doc.text(`$${item.unitPrice.toFixed(2)}`, 140, y + 7);
//       doc.text(`$${item.total.toFixed(2)}`, 170, y + 7);
//       y += 10;
//     });

//     // Totals
//     const subtotal = items.reduce((sum, item) => sum + item.total, 0);
//     const tax = subtotal * 0.1;
//     const total = subtotal + tax;

//     y += 15;
//     doc.setFontSize(12);
//     doc.text('Subtotal:', 140, y);
//     doc.text(`$${subtotal.toFixed(2)}`, 170, y);
//     y += 10;
//     doc.text('Tax (10%):', 140, y);
//     doc.text(`$${tax.toFixed(2)}`, 170, y);
//     y += 10;
//     doc.setFontSize(14);
//     doc.setFont(undefined, 'bold');
//     doc.text('TOTAL:', 140, y);
//     doc.text(`$${total.toFixed(2)}`, 170, y);

//     // Notes
//     y += 20;
//     doc.setFontSize(10);
//     doc.setFont(undefined, 'normal');
//     doc.text('Notes:', 20, y);
//     doc.text('1. This quotation is valid for 30 days from the date of issue.', 25, y + 7);
//     doc.text('2. Payment terms: 50% advance, 50% upon completion.', 25, y + 14);
//     doc.text('3. Prices include all materials and labor unless otherwise specified.', 25, y + 21);

//     // Footer
//     doc.setFontSize(8);
//     doc.setTextColor(100, 100, 100);
//     doc.text('Thank you for choosing Landnest Construction!', 105, 280, { align: 'center' });
//     doc.text('Terms and conditions apply', 105, 285, { align: 'center' });

//     // Save the PDF
//     doc.save(`Landnest_Quotation_${new Date().toISOString().split('T')[0]}.pdf`);
//   };



//   const rows = chunkArray(steps, chunkSize);

// return (
//     <>
//       {/* Sticky Header Section */}
//       <Box sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         zIndex: 1200,
//         bgcolor: 'background.paper',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//       }}>
//         {/* Top Navigation Bar */}
//         <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{
//           background: 'black',
//           borderBottom: '1px solid rgba(0,0,0,0.08)'
//         }}>
//           {/* Back Arrow - Left Side */}
//           <IconButton
//             onClick={() => navigate(-1)}
//             sx={{
//               color: 'white',
//               '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
//             }}
//           >
//             <ArrowBackIosIcon />
//           </IconButton>

//           <Typography variant="h7" component="div" sx={{
//             color: 'white',
//             fontWeight: 'bold',
//             flexGrow: 1,
//             textAlign: 'left'
//           }}>
//             PROPERTY PINCODER
//           </Typography>

//           {/* Right Side Logo */}
//           <Box
//             sx={{
//               width: 90,
//               height: 50,
//               boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.6)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             <img
//               src={property_pincode_new}
//               alt="Property_pincoder Logo"
//               style={{
//                 maxWidth: '100%',
//                 maxHeight: '100%',
//                 objectFit: 'contain'
//               }}
//             />
//           </Box>
//         </Box>
        
//         {/* Fixed Navigation Tabs */}
//         <Box sx={{
//           padding: isMobile ? 1 : 0.5,
//           display: 'flex',
//           justifyContent: 'space-between',
//           boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
//         }}>
//           <Box
//             component={Link}
//             to="/constructions"
//             sx={{
//               flex: 1,
//               textAlign: 'center',
//               py: 2,
//               textDecoration: 'none',
//               position: 'relative',
//               background: `
//                 linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
//                 url('/construction4.png')
//               `,
//               backgroundBlendMode: 'overlay',
//               borderRight: '1px solid rgba(0,0,0,0.1)',
//               borderTopLeftRadius: '30px',
//               boxShadow: location.pathname === '/constructions'
//                 ? `
//                     inset 0 0 15px rgba(0,0,0,0.2),
//                     0 4px 10px rgba(0,0,0,0.15)
//                   `
//                 : `
//                     inset 0 0 15px rgba(0,0,0,0.1),
//                     0 2px 5px rgba(0,0,0,0.08)
//                   `,
//               transform: location.pathname === '/constructions' ? 'scale(1.05)' : 'scale(0.95)',
//               transition: 'all 0.3s ease',
//               zIndex: location.pathname === '/constructions' ? 1 : 0,
//               '&:hover': {
//                 transform: location.pathname === '/constructions' ? 'scale(1.08)' : 'scale(0.98)',
//                 boxShadow: `
//                   inset 0 0 20px rgba(0,0,0,0.15),
//                   0 3px 8px rgba(0,0,0,0.15)
//                 `,
//                 '&::after': {
//                   width: '70%',
//                   backgroundColor: '#333333',
//                 }
//               },
//               '&::after': {
//                 content: '""',
//                 position: 'absolute',
//                 bottom: 0,
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 width: location.pathname === '/constructions' ? '70%' : '0%',
//                 height: '3px',
//                 backgroundColor: location.pathname === '/constructions' ? '#333333' : 'transparent',
//                 borderRadius: '3px',
//                 transition: 'all 0.3s ease',
//               }
//             }}>
//             <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
//               fontWeight: 700,
//               color: '#333333',
//               textShadow: '0 1px 3px rgba(255,255,255,0.5)',
//               fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
//               transform: location.pathname === '/constructions' ? 'scale(1.1)' : 'scale(1)',
//               transition: 'transform 0.3s ease',
//             }}>
//               Constructions
//             </Typography>
//           </Box>

//           <Box
//             component={Link}
//             to="/interiors"
//             sx={{
//               flex: 1,
//               textAlign: 'center',
//               py: 2,
//               position: 'relative',
//               background: `
//                 linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
//                 url('/construction5.png')
//               `,
//               backgroundBlendMode: 'overlay',
//               textDecoration: 'none',
//               borderBottomRightRadius: '30px',
//               boxShadow: location.pathname === '/interiors'
//                 ? `
//                     inset 0 0 15px rgba(0,0,0,0.3),
//                     0 4px 10px rgba(0,0,0,0.2)
//                   `
//                 : `
//                     inset 0 0 15px rgba(0,0,0,0.2),
//                     0 2px 5px rgba(0,0,0,0.1)
//                   `,
//               transform: location.pathname === '/interiors' ? 'scale(1.05)' : 'scale(0.95)',
//               transition: 'all 0.3s ease',
//               zIndex: location.pathname === '/interiors' ? 1 : 0,
//               '&:hover': {
//                 background: `
//                   linear-gradient(145deg, rgb(35, 35, 35), rgb(25, 25, 25)),
//                   url('/construction5.png')
//                 `,
//                 transform: location.pathname === '/interiors' ? 'scale(1.08)' : 'scale(0.98)',
//                 boxShadow: `
//                   inset 0 0 20px rgba(0,0,0,0.3),
//                   0 3px 8px rgba(0,0,0,0.2)
//                 `,
//                 '&::after': {
//                   width: '70%',
//                   backgroundColor: 'rgba(255,255,255,0.9)',
//                 }
//               },
//               '&::after': {
//                 content: '""',
//                 position: 'absolute',
//                 bottom: 0,
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 width: location.pathname === '/interiors' ? '70%' : '0%',
//                 height: '3px',
//                 backgroundColor: location.pathname === '/interiors' ? 'rgba(255,255,255,0.9)' : 'transparent',
//                 borderRadius: '3px',
//                 transition: 'all 0.3s ease',
//               }
//             }}
//           >
//             <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
//               fontWeight: 700,
//               color: 'rgba(255,255,255,0.9)',
//               letterSpacing: '1px',
//               textShadow: '0 1px 5px rgba(0,0,0,0.7)',
//               fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
//               transform: location.pathname === '/interiors' ? 'scale(1.1)' : 'scale(1)',
//               transition: 'transform 0.3s ease',
//             }}>
//               Interiors
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* Scrollable Main Content */}
//       <Box sx={{ 
//         mt: '140px', // Adjust this value based on the actual height of your fixed header
//         height: 'calc(100vh - 130px)', // Subtract header height from viewport height
//         overflowY: 'auto',
//         pb: 2
//       }}>
//         <Box sx={{
//           background: "#e7dbc9",
//           padding: isMobile ? 2 : 2,
//         }}>
//           <Box sx={{ width: '100%' }}>
//             {cards.map((card, index) => (
//               <Card
//                 key={index}
//                 onClick={() => {
//                   if (card.path) {
//                     navigate(card.path);
//                   } else if (card.title == "Quotations") {
//                     handleDownloadQuotation();
//                   }
//                 }}
//                 sx={{
//                   backgroundImage: `${card.bgImage}`,
//                   backgroundSize: 'cover',
//                   backgroundPosition: 'center',
//                   minHeight: 200,
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'flex-end',
//                   color: 'white',
//                   position: 'relative',
//                   borderRadius: '12px',
//                   boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
//                   mb: 3,
//                   cursor: 'pointer',
//                   '&::before': {
//                     content: '""',
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     borderRadius: '12px'
//                   }
//                 }}
//               >
//                 <CardContent
//                   sx={{
//                     position: 'relative',
//                     zIndex: 1,
//                     width: '100%',
//                     padding: isMobile ? 2 : 2,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     height: '100%',
//                     boxSizing: 'border-box',
//                     '&:last-child': { paddingBottom: isMobile ? 1 : 3 }
//                   }}
//                 >
//                   {/* TITLE AT TOP — ONLY IF DESCRIPTION EXISTS */}
//                   {card.description && (
//                     <Box sx={{ flex: 1 }}>
//                       <Typography
//                         variant="h6"
//                         fontWeight="bold"
//                         sx={{
//                           lineHeight: 1.3,
//                           margin: 0,
//                           padding: 0
//                         }}
//                       >
//                         {card.title}
//                       </Typography>
//                     </Box>
//                   )}

//                   {/* BOTTOM ROW */}
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'flex-end',
//                       justifyContent: 'space-between',
//                       width: '100%'
//                     }}
//                   >
//                     {/* LEFT SIDE */}
//                     <Box sx={{ flex: 1 }}>
//                       {card.description ? (
//                         /* DESCRIPTION */
//                         <Typography
//                           variant="body1"
//                           sx={{
//                             lineHeight: 1.2,
//                             margin: 0,
//                             padding: 0
//                           }}
//                         >
//                           {card.description}
//                         </Typography>
//                       ) : (
//                         <Typography
//                           variant="h6"
//                           fontWeight="bold"
//                           sx={{
//                             lineHeight: 1.3,
//                             margin: 0,
//                             padding: 0
//                           }}
//                         >
//                           {card.title}
//                         </Typography>
//                       )}
//                     </Box>

//                     {/* ARROW — ALWAYS VISIBLE */}
//                     {card.path && (
//                       <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
//                         <Box
//                           sx={{
//                             backgroundColor: '#000000be',  
//                             borderRadius: '50%',
//                             width: 39,
//                             height: 37,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             transition: 'transform 0.3s ease',
//                             '&:hover': {
//                               backgroundColor: '#000000ff',
//                             },
//                           }}
//                         >
//                           <img
//                             src={Arrowicon}
//                             alt="arrowicon"
//                             style={{
//                               width: 30,
//                               height: 30,
//                               objectFit: 'contain'
//                             }}
//                           />
//                         </Box>
//                       </Box>
//                     )}
//                   </Box>
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>

//           <Box sx={{ textAlign: 'center' }}>
//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: 'red',
//                 color: '#fff',
//                 borderRadius: '20px',
//                 px: 4,
//                 py: 1,
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#cc0000',
//                 },
//               }}
//               onClick={() => navigate('/construction-get-started')}
//             >
//               GET FREE CONSULTATION
//             </Button>
//           </Box>
//         </Box>

//         <Box sx={{ padding: 2, marginY: 1 }}>
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             gutterBottom
//             sx={{
//               textAlign: 'center',
//               mb: 2,
//               color: 'primary.main',
//               fontSize: '1.5rem',
//               paddingLeft: 1
//             }}
//           >
//             Landnest & bold Trust
//           </Typography>

//           <Box sx={{
//             display: 'flex',
//             gap: 1,
//             width: 'max-content',
//             minWidth: '100%',
//           }}>
//             {trustCards.map((card, index) => (
//               <Card key={index} sx={{
//                 backgroundImage: `${card.bgImage}`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 height: 100,
//                 minWidth: '100px',
//                 flex: 1,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'flex-end',
//                 position: 'relative',
//                 borderRadius: '8px',
//                 overflow: 'hidden',
//                 boxShadow: 1,
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)'
//                 }
//               }}>
//                 <CardContent sx={{
//                   position: 'relative',
//                   zIndex: 1,
//                   color: 'white',
//                   padding: 1.5,
//                   '&:last-child': { paddingBottom: 1.5 }
//                 }}>
//                   <Typography variant="subtitle2" fontWeight="bold" gutterBottom sx={{
//                     fontSize: '0.9rem',
//                     lineHeight: 1.2
//                   }}>
//                     {card.title}
//                   </Typography>
//                   <Typography variant="caption" sx={{
//                     fontSize: '0.7rem',
//                     lineHeight: 1.1,
//                     display: 'block'
//                   }}>
//                     {card.description}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         </Box>

//         <Box sx={{ px: 2, py: 1, bgcolor: '#e7dbc9', paddingBottom: '40px', marginBottom: '40px' }}>
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             gutterBottom
//             sx={{
//               textAlign: 'center',
//               mb: 2,
//               color: 'primary.main',
//               fontSize: '1.5rem',
//               paddingLeft: 1
//             }}
//           >
//             Our Construction Process
//           </Typography>
//           {rows.map((row, rowIndex) => (
//             <Box
//               key={rowIndex}
//               display="flex"
//               gap={2}
//               mb={2}
//             >
//               {row.map((item) => (
//                 <Card
//                   key={item.id}
//                   sx={{
//                     flex: 1,
//                     borderRadius: 2,
//                     boxShadow: 3,
//                     height: '160px',
//                     '&:hover': {
//                       transform: 'translateY(-4px)',
//                       transition: 'transform 0.3s ease'
//                     }
//                   }}
//                 >
//                   <CardMedia
//                     component="img"
//                     height="125"
//                     image={item.image}
//                     alt={item.title}
//                     sx={{ objectFit: 'cover' }}
//                   />
//                   <CardContent sx={{ padding: '8px' }}>
//                     <Typography variant="subtitle1" align="center" fontWeight="bold">
//                       {item.title}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               ))}
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       <FormsBottomNavbar />
//     </>
//   );
// };

// export default Constructions;



import { useNavigate } from 'react-router-dom';
import {
  Box, Grid, Typography, useTheme, useMediaQuery, Card, CardContent, IconButton,
  CardMedia, Container, BottomNavigation,
  BottomNavigationAction, Paper, Button
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import React, { useEffect, useState } from 'react';
import pic4 from "./../../../Images/roofshuttering.webp";

import soiltest1 from "./../../../Images/soiltest.webp";
import pic1 from "./../../../Images/column_marking.webp";
import pic2 from "./../../../Images/columnfoundation.jpg";
import pic3 from "./../../../Images/plinth.avif";
import pic5 from "./../../../Images/roofbarbending.jpg";
import pic6 from "./../../../Images/roofconcreate.jpg";
import pic7 from "./../../../Images/partitionwalls.jpg";
import pic8 from "./../../../Images/flooring.jpg";
import pic9 from "./../../../Images/electricals.jpg";
import pic10 from "./../../../Images/plumbing.webp";
import pic11 from "./../../../Images/fabrication.jpg";
import pic12 from "./../../../Images/doors_windows.jpg";
import pic13 from "./../../../Images/paintings.jpg";
import pic14 from "./../../../Images/handover.jpg";
import pic15 from "./../../../Images/agreement.webp";
import { jsPDF } from "jspdf";
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import const1 from './Images/Constructionelevation.jpg'
import const2 from './Images/2dnewpic.jpg'
import const3 from './Images/construction3d.jpg'
import const4 from './Images/constructionpackages.jpeg'
import const5 from './Images/Quotations.png';
import property_pincode_new from './../../../../src/Images/property_pincode_new.png'
import Arrowicon from "./../Dashboard/Images/Arrowicon.png";

import expimag from './Images/exp-constru-resources.jpeg';
import Construction1 from './../../../Assets/construction1.png';
import Construction2 from './../../../Assets/construction2.png';
import Construction3 from './../../../Assets/construction3.png';

// ─── Remote image URLs (no local imports needed) ──────────────
const HERO_IMG = "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=900&q=80";
const IMG_MATERIALS = "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=400&q=70";
const IMG_GUIDES = "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=400&q=70";
const IMG_VIDEOS = "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=400&q=70";
const IMG_CALCULATOR = "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=400&q=70";

const IMG_PLAN2D = "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=400&q=70";
const IMG_PLAN3D = "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=400&q=70";
const IMG_ELEV = "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=400&q=70";
const IMG_INTERIOR = "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=400&q=70";

const IMG_PKG_BASIC = "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=400&q=70";
const IMG_PKG_STD = "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=400&q=70";
const IMG_PKG_PREM = "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=400&q=70";

const IMG_PROG_SITE = "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=400&q=70";
const IMG_PROG_FOUND = "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=400&q=70";
const IMG_PROG_COL = "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=400&q=70";
const IMG_PROG_WALL = "https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?auto=format&fit=crop&w=400&q=70";
const IMG_PROG_ROOF = "https://images.unsplash.com/photo-1590725121839-892b458a74fe?auto=format&fit=crop&w=400&q=70";

const CTA_IMG = "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=400&q=70";

// ─── Data for the various sections ────────────────────────────
const resources = [
  {
    title: 'Materials Resource',
    subtitle: 'Details and quality building materials',
    image: IMG_MATERIALS,
  },
  {
    title: 'Guides & Articles',
    subtitle: 'Construction tips, new articles, checklists',
    image: IMG_GUIDES,
  },
  {
    title: 'Videos & Tutorials',
    subtitle: 'Step-by-step construction knowledge',
    image: IMG_VIDEOS,
  },
  {
    title: 'Cost Calculator',
    subtitle: 'Estimate your construction cost',
    image: IMG_CALCULATOR,
  },
];

const designPlanning = [
  { title: 'Floor Plans 2D', subtitle: 'Professional 2D plans with measurements', image: IMG_PLAN2D, path: '/two-d-plane-interior' },
  { title: 'Floor Plans 3D', subtitle: '3D plans with realistic views', image: IMG_PLAN3D, path: '/three-d-plane-interior' },
  { title: 'Elevations', subtitle: 'Exterior views & facade designs', image: IMG_ELEV, path: '/elevations' },
  { title: 'Interior Designs', subtitle: 'Modern interior concepts', image: IMG_INTERIOR, path: '/interiors' },
];

const packages = [
  {
    title: 'Basic Package',
    price: '₹1,800 / sq.ft',
    image: IMG_PKG_BASIC,
    features: ['Standard materials', 'Basic finishes', 'Electrical', 'Plumbing'],
  },
  {
    title: 'Standard Package',
    price: '₹2,200 / sq.ft',
    image: IMG_PKG_STD,
    features: ['Branded materials', 'Premium quality', 'Quality materials', 'Modern finishes'],
  },
  {
    title: 'Premium Package',
    price: '₹2,800 / sq.ft',
    image: IMG_PKG_PREM,
    features: ['Premium materials', 'Luxury finishes', 'Supervision', 'High-end fixtures'],
  },
  {
    title: 'Custom Package',
    price: 'Get Quote',
    image: IMG_PKG_PREM,
    features: ['Fully customized', 'Architectural & commercial', 'End-to-end support'],
  },
];

const processSteps = [
  { num: 1, label: 'Requirements', sub: 'Consultation' },
  { num: 2, label: 'Site Visit', sub: 'Soil Test' },
  { num: 3, label: 'Design & Drawings', sub: '2D / 3D' },
  { num: 4, label: 'Approvals', sub: 'Permissions' },
  { num: 5, label: 'Construction Execution', sub: 'On-Site' },
  { num: 6, label: 'Quality Check', sub: 'Inspection' },
  { num: 7, label: 'Handover', sub: 'Delivered' },
];

const constructionProgress = [
  { title: 'Site Marking', image: IMG_PROG_SITE },
  { title: 'Foundation', image: IMG_PROG_FOUND },
  { title: 'Column & Plinth', image: IMG_PROG_COL },
  { title: 'Wall Construction', image: IMG_PROG_WALL },
  { title: 'Roof Work', image: IMG_PROG_ROOF },
];

const steps = [
  { title: 'Agreement Sign', image: pic15 },
  { title: 'Soil Test', image: soiltest1 },
  { title: 'Column Marking', image: pic1 },
  { title: 'Column Foundation', image: pic2 },
  { title: 'Column Plinth', image: pic3 },
  { title: 'Roof Shuttering', image: pic4 },
  { title: 'Roof Barbending', image: pic5 },
  { title: 'Roof Concrete', image: pic6 },
  { title: 'Partitions Wall', image: pic7 },
  { title: 'Flooring', image: pic8 },
  { title: 'Electrical', image: pic9 },
  { title: 'Plumbing', image: pic10 },
  { title: 'Fabrication', image: pic11 },
  { title: 'Doors and Windows', image: pic12 },
  { title: 'Paintings', image: pic13 },
  { title: 'Handover', image: pic14 },
];

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

// ─── Section header with optional "View All" ─────────────────
const SectionHeader = ({ title, onViewAll }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 1.5,
      mt: 3,
    }}
  >
    <Typography
      sx={{
        fontWeight: 800,
        fontSize: '1.05rem',
        color: '#2b2b2b',
        letterSpacing: 0.2,
      }}
    >
      {title}
    </Typography>
    {onViewAll && (
      <Typography
        onClick={onViewAll}
        sx={{
          fontSize: '0.82rem',
          color: '#b45309',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 0.25,
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        View All <ArrowForwardIcon sx={{ fontSize: 15 }} />
      </Typography>
    )}
  </Box>
);

const Constructions = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [chunkSize, setChunkSize] = useState(2);
  const [value, setValue] = useState('construction');
  const location = useLocation();

  useEffect(() => {
    const updateChunkSize = () => {
      const width = window.innerWidth;
      if (width >= 350 && width <= 500) {
        setChunkSize(2);
      } else {
        setChunkSize(1);
      }
    };
    updateChunkSize();
    window.addEventListener('resize', updateChunkSize);
    return () => window.removeEventListener('resize', updateChunkSize);
  }, []);

  const handleDownloadQuotation = () => {
    const doc = new jsPDF();
    doc.setFontSize(20);
    doc.setTextColor(40, 40, 40);
    doc.text('CONSTRUCTION QUOTATION', 105, 30, { align: 'center' });
    doc.setFontSize(12);
    doc.text('Landnest Construction Co.', 105, 40, { align: 'center' });
    doc.text('123 Construction Street, City, Country', 105, 46, { align: 'center' });
    doc.text('Phone: +123 456 7890 | Email: contact@landnest.com', 105, 52, { align: 'center' });
    doc.setFontSize(12);
    doc.text('Bill To:', 20, 70);
    doc.text('Client Name: Sample Client', 20, 78);
    doc.text('Project Address: 123 Client Street, City', 20, 86);
    doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 94);
    doc.text('Quotation #: Q-2023-001', 20, 102);
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255);
    doc.setFillColor(57, 106, 177);
    doc.rect(20, 110, 170, 10, 'F');
    doc.text('Description', 25, 116);
    doc.text('Qty', 120, 116);
    doc.text('Unit Price', 140, 116);
    doc.text('Amount', 170, 116);
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    const items = [
      { description: "Construction Materials (Phase 1)", quantity: 1, unitPrice: 5000, total: 5000 },
      { description: "Labor Costs (200 hours)", quantity: 1, unitPrice: 3000, total: 3000 },
      { description: "Design and Planning Fees", quantity: 1, unitPrice: 2000, total: 2000 },
      { description: "Permits and Approvals", quantity: 1, unitPrice: 500, total: 500 },
      { description: "Roofing Materials", quantity: 1, unitPrice: 2500, total: 2500 },
      { description: "Electrical Installation", quantity: 1, unitPrice: 1500, total: 1500 }
    ];
    let y = 120;
    items.forEach((item, index) => {
      if (index % 2 == 0) {
        doc.setFillColor(240, 240, 240);
        doc.rect(20, y, 170, 10, 'F');
      }
      doc.text(item.description, 25, y + 7);
      doc.text(item.quantity.toString(), 120, y + 7);
      doc.text(`$${item.unitPrice.toFixed(2)}`, 140, y + 7);
      doc.text(`$${item.total.toFixed(2)}`, 170, y + 7);
      y += 10;
    });
    const subtotal = items.reduce((sum, item) => sum + item.total, 0);
    const tax = subtotal * 0.1;
    const total = subtotal + tax;
    y += 15;
    doc.setFontSize(12);
    doc.text('Subtotal:', 140, y);
    doc.text(`$${subtotal.toFixed(2)}`, 170, y);
    y += 10;
    doc.text('Tax (10%):', 140, y);
    doc.text(`$${tax.toFixed(2)}`, 170, y);
    y += 10;
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('TOTAL:', 140, y);
    doc.text(`$${total.toFixed(2)}`, 170, y);
    y += 20;
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Notes:', 20, y);
    doc.text('1. This quotation is valid for 30 days from the date of issue.', 25, y + 7);
    doc.text('2. Payment terms: 50% advance, 50% upon completion.', 25, y + 14);
    doc.text('3. Prices include all materials and labor unless otherwise specified.', 25, y + 21);
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Thank you for choosing Landnest Construction!', 105, 280, { align: 'center' });
    doc.text('Terms and conditions apply', 105, 285, { align: 'center' });
    doc.save(`Landnest_Quotation_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  const rows = chunkArray(steps, chunkSize);

  return (
    <>
      {/* ───────────── Fixed Header (UNCHANGED) ───────────── */}
      <Box sx={{
        position: 'fixed',
        top: 0, left: 0, right: 0,
        zIndex: 1200,
        bgcolor: 'background.paper',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{
          background: 'black',
          borderBottom: '1px solid rgba(0,0,0,0.08)'
        }}>
          <IconButton
            onClick={() => navigate(-1)}
            sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
          >
            <ArrowBackIosIcon />
          </IconButton>

          <Typography variant="h7" component="div" sx={{
            color: 'white', fontWeight: 'bold', flexGrow: 1, textAlign: 'left'
          }}>
            PROPERTY PINCODER
          </Typography>

          <Box sx={{
            width: 90, height: 40,
            boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <img
              src={property_pincode_new}
              alt="Property_pincoder Logo"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          </Box>
        </Box>

        <Box sx={{
          padding: isMobile ? 1 : 0.5,
          display: 'flex',
          justifyContent: 'space-between',
          boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
        }}>
          {/* Constructions tab */}
          <Box
            component={Link}
            to="/constructions"
            sx={{
              flex: 1, textAlign: 'center', py: 1, textDecoration: 'none',
              position: 'relative',
              background: `linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)), url('/construction4.png')`,
              backgroundBlendMode: 'overlay',
              borderRight: '1px solid rgba(0,0,0,0.1)',
              borderTopLeftRadius: '30px',
              boxShadow: location.pathname === '/constructions'
                ? `inset 0 0 15px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.15)`
                : `inset 0 0 15px rgba(0,0,0,0.1), 0 2px 5px rgba(0,0,0,0.08)`,
              transform: location.pathname === '/constructions' ? 'scale(1.05)' : 'scale(0.95)',
              transition: 'all 0.3s ease',
              zIndex: location.pathname === '/constructions' ? 1 : 0,
              '&::after': {
                content: '""', position: 'absolute', bottom: 0,
                left: '50%', transform: 'translateX(-50%)',
                width: location.pathname === '/constructions' ? '70%' : '0%',
                height: '3px',
                backgroundColor: location.pathname === '/constructions' ? '#333333' : 'transparent',
                borderRadius: '3px', transition: 'all 0.3s ease',
              }
            }}>
            <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
              fontWeight: 700, color: '#333333',
              textShadow: '0 1px 3px rgba(255,255,255,0.5)',
              fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
            }}>
              Constructions
            </Typography>
          </Box>

          {/* Interiors tab */}
          <Box
            component={Link}
            to="/interiors"
            sx={{
              flex: 1, textAlign: 'center', py: 1, position: 'relative',
              background: `linear-gradient(145deg, rgb(22,22,22), rgb(15,15,15)), url('/construction5.png')`,
              backgroundBlendMode: 'overlay',
              textDecoration: 'none',
              borderBottomRightRadius: '30px',
              boxShadow: location.pathname === '/interiors'
                ? `inset 0 0 15px rgba(0,0,0,0.3), 0 4px 10px rgba(0,0,0,0.2)`
                : `inset 0 0 15px rgba(0,0,0,0.2), 0 2px 5px rgba(0,0,0,0.1)`,
              transform: location.pathname === '/interiors' ? 'scale(1.05)' : 'scale(0.95)',
              transition: 'all 0.3s ease',
            }}
          >
            <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
              fontWeight: 700, color: 'rgba(255,255,255,0.9)',
              letterSpacing: '1px',
              textShadow: '0 1px 5px rgba(0,0,0,0.7)',
              fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
            }}>
              Interiors
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ───────────── Main Scrollable Content ───────────── */}
      <Box sx={{
        mt: '140px',
        height: 'calc(100vh - 130px)',
        overflowY: 'auto',
        pb: 2,
        backgroundColor: '#f6f1e7',
      }}>
        <Box sx={{ padding: 2 }}>

          {/* ═══════ HERO CARD ═══════ */}
          <Card
            sx={{
              position: 'relative',
              borderRadius: '16px',
              overflow: 'hidden',
              mb: 1,
              boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            }}
          >
            <Box
              component="img"
              src={HERO_IMG}
              alt="Construction Solutions"
              sx={{ width: '100%', height: 200, objectFit: 'cover', display: 'block' }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                background:
                  'linear-gradient(to top, rgba(15,15,15,0.85) 10%, rgba(15,15,15,0.35) 60%, rgba(0,0,0,0.15) 100%)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                p: 1.7,
              }}
            >
              {/* Top pills: Plan | Design | Build | Deliver */}
              <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
                {['Plan', 'Design', 'Build', 'Deliver'].map((t) => (
                  <Box
                    key={t}
                    sx={{
                      fontSize: '0.72rem',
                      color: '#fff',
                      px: 1.1, py: 0.35,
                      borderRadius: '999px',
                      backgroundColor: 'rgba(255,255,255,0.14)',
                      border: '1px solid rgba(255,255,255,0.35)',
                      fontWeight: 600,
                    }}
                  >
                    {t}
                  </Box>
                ))}
              </Box>

              <Box>
                <Typography sx={{
                  color: '#fff', fontWeight: 800, fontSize: '1.3rem',
                  lineHeight: 1.15, mb: 0.5,
                }}>
                  Complete<br />Construction<br />Solutions
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.8rem', mb: 1 }}>
                  From residential to commercial,<br />we build your vision.
                </Typography>
                <Button
                  onClick={() => navigate('/construction-get-started')}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    backgroundColor: '#a5610f',
                    color: '#fff',
                    textTransform: 'none',
                    borderRadius: '10px',
                    px: 2.2, py: 0.9,
                    fontWeight: 700,
                    fontSize: '0.85rem',
                    '&:hover': { backgroundColor: '#8a4f0c' },
                  }}
                >
                  Get Free Consultation
                </Button>
              </Box>
            </Box>
          </Card>

          {/* ═══════ EXPLORE CONSTRUCTION RESOURCES ═══════ */}
          <SectionHeader
            title="Explore Construction Resources"
            onViewAll={() => navigate('/explore-construction-resources')}
          />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 1,
            }}
          >
            {resources.map((r) => (
              <Card
                key={r.title}
                onClick={() => navigate('/explore-construction-resources')}
                sx={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  '&:hover': { transform: 'translateY(-2px)', transition: 'all 0.2s' },
                }}
              >
                <Box component="img" src={r.image} alt={r.title}
                  sx={{ width: '100%', height: 70, objectFit: 'cover', display: 'block' }} />
                <Box sx={{ p: 1 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.72rem', color: '#2b2b2b', lineHeight: 1.2 }}>
                    {r.title}
                  </Typography>
                  <Typography sx={{ fontSize: '0.6rem', color: '#6b5c42', lineHeight: 1.25, mt: 0.25 }}>
                    {r.subtitle}
                  </Typography>
                </Box>
              </Card>
            ))}
          </Box>

          {/* ═══════ DESIGN & PLANNING ═══════ */}
          <SectionHeader
            title="Design & Planning"
            onViewAll={() => navigate('/two-d-plane-interior')}
          />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 1,
            }}
          >
            {designPlanning.map((d) => (
              <Card
                key={d.title}
                onClick={() => d.path && navigate(d.path)}
                sx={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  '&:hover': { transform: 'translateY(-2px)', transition: 'all 0.2s' },
                }}
              >
                <Box component="img" src={d.image} alt={d.title}
                  sx={{ width: '100%', height: 70, objectFit: 'cover', display: 'block' }} />
                <Box sx={{ p: 1 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.72rem', color: '#2b2b2b', lineHeight: 1.2 }}>
                    {d.title}
                  </Typography>
                  <Typography sx={{ fontSize: '0.6rem', color: '#6b5c42', lineHeight: 1.25, mt: 0.25 }}>
                    {d.subtitle}
                  </Typography>
                </Box>
              </Card>
            ))}
          </Box>

          {/* ═══════ CONSTRUCTION PACKAGES ═══════ */}
          <SectionHeader
            title="Construction Packages"
            onViewAll={() => navigate('/packages')}
          />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 1,
            }}
          >
            {packages.map((p) => (
              <Card
                key={p.title}
                onClick={() => navigate('/packages')}
                sx={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': { transform: 'translateY(-2px)', transition: 'all 0.2s' },
                }}
              >
                <Box component="img" src={p.image} alt={p.title}
                  sx={{ width: '100%', height: 70, objectFit: 'cover', display: 'block' }} />
                <Box sx={{ p: 1, flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.72rem', color: '#2b2b2b', lineHeight: 1.2 }}>
                    {p.title}
                  </Typography>
                  <Typography sx={{ fontSize: '0.68rem', color: '#b45309', fontWeight: 700, mt: 0.25 }}>
                    {p.price}
                  </Typography>
                  <Box component="ul" sx={{
                    pl: 1.5, mt: 0.5, mb: 0,
                    fontSize: '0.58rem', color: '#6b5c42', lineHeight: 1.35,
                  }}>
                    {p.features.slice(0, 3).map((f) => (
                      <li key={f}>{f}</li>
                    ))}
                  </Box>
                </Box>
              </Card>
            ))}
          </Box>

          {/* ═══════ OUR CONSTRUCTION PROCESS ═══════ */}
          <SectionHeader title="Our Construction Process" />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: 1,
              mt: 1,
            }}
          >
            {processSteps.map((s, i) => (
              <Box key={s.num} sx={{ textAlign: 'center', position: 'relative' }}>
                <Box
                  sx={{
                    width: 32, height: 32, mx: 'auto',
                    borderRadius: '50%',
                    backgroundColor: '#a5610f',
                    color: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontWeight: 700, fontSize: '0.78rem',
                  }}
                >
                  {s.num}
                </Box>
                <Typography sx={{ fontSize: '0.6rem', fontWeight: 700, color: '#2b2b2b', mt: 0.5, lineHeight: 1.15 }}>
                  {s.label}
                </Typography>
                <Typography sx={{ fontSize: '0.55rem', color: '#8a7a5c', lineHeight: 1.15 }}>
                  {s.sub}
                </Typography>

                {/* dotted connector */}
                {i < processSteps.length - 1 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 15,
                      left: 'calc(50% + 16px)',
                      right: 'calc(-50% + 16px)',
                      borderTop: '2px dotted #b48a4a',
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>

          {/* ═══════ CONSTRUCTION PROGRESS ═══════ */}
          <SectionHeader
            title="Construction Progress"
            onViewAll={() => navigate('/construction-progress')}
          />
          <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', pb: 0.5 }}>
            {constructionProgress.map((p) => (
              <Card
                key={p.title}
                sx={{
                  minWidth: 120,
                  flex: '0 0 auto',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                }}
              >
                <Box component="img" src={p.image} alt={p.title}
                  sx={{ width: '100%', height: 70, objectFit: 'cover', display: 'block' }} />
                <Typography sx={{
                  fontSize: '0.65rem', fontWeight: 700,
                  textAlign: 'center', py: 0.6, color: '#2b2b2b',
                }}>
                  {p.title}
                </Typography>
              </Card>
            ))}
          </Box>

          {/* ═══════ CTA CARD ═══════ */}
          <Card
            sx={{
              mt: 3,
              borderRadius: '14px',
              overflow: 'hidden',
              boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
              position: 'relative',
              backgroundColor: '#1f1305',
            }}
          >
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              p: 1.5,
              gap: 1.5,
            }}>
              <Box
                component="img"
                src={CTA_IMG}
                alt="Custom quote"
                sx={{
                  width: 70, height: 70,
                  objectFit: 'cover',
                  borderRadius: '10px',
                  flexShrink: 0,
                }}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{
                  color: '#fff', fontWeight: 800, fontSize: '0.88rem', lineHeight: 1.2,
                }}>
                  Need a Custom Construction Quote?
                </Typography>
                <Typography sx={{
                  color: 'rgba(255,255,255,0.75)', fontSize: '0.68rem', lineHeight: 1.25, mt: 0.25,
                }}>
                  Get expert consultation for your dream project.
                </Typography>
              </Box>
              <Button
                onClick={() => navigate('/construction-get-started')}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#a5610f', color: '#fff',
                  textTransform: 'none', borderRadius: '8px',
                  px: 1.5, py: 0.7, fontWeight: 700,
                  fontSize: '0.7rem', flexShrink: 0,
                  '&:hover': { backgroundColor: '#8a4f0c' },
                }}
              >
                Contact Now
              </Button>
            </Box>
          </Card>

          {/* Existing "Our Construction Process" gallery (kept) */}
          {/* <Box sx={{ mt: 4 }}>
            <SectionHeader title="Our Construction Gallery" />
            {rows.map((row, rowIndex) => (
              <Box key={rowIndex} display="flex" gap={2} mb={2}>
                {row.map((item) => (
                  <Card
                    key={item.title}
                    sx={{
                      flex: 1,
                      borderRadius: 2,
                      boxShadow: 3,
                      height: '160px',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        transition: 'transform 0.3s ease',
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="125"
                      image={item.image}
                      alt={item.title}
                      sx={{ objectFit: 'cover' }}
                    />
                    <CardContent sx={{ padding: '8px' }}>
                      <Typography variant="subtitle1" align="center" fontWeight="bold">
                        {item.title}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ))}
          </Box> */}

          {/* Bottom spacer */}
          <Box sx={{ height: 60 }} />
        </Box>
      </Box>

      <FormsBottomNavbar />
    </>
  );
};

export default Constructions;